import { DataAction, Payload, Persistence, StateRepository } from '@angular-ru/ngxs/decorators';
import { Injectable } from '@angular/core';
import { State, Store, NgxsOnInit } from '@ngxs/store';
import { NgxsDataRepository } from '@angular-ru/ngxs/repositories';
import { produce } from 'immer';
import { MemberService } from './member/member.service';

export interface IMemberHistory {
    id: string;
    tenantId: string;
    base64: string;
    firstName: string;
    lastName: string;
    url: string;
    date: Date;
}

export interface IMemberHistoryModel {
    loadedMembers: IMemberHistory[];
}

@Persistence()
@StateRepository()
@State<IMemberHistoryModel>({
    name: 'memberHistoryState',
    defaults: {
        loadedMembers: []
    }
})
@Injectable({ providedIn: 'root' })
export class MemberHistoryService extends NgxsDataRepository<IMemberHistoryModel> implements NgxsOnInit {

  constructor(
      private readonly store: Store,
  ) {
      super();
  }

  ngxsAfterBootstrap() {

    super.ngxsAfterBootstrap();

    this.store.select(MemberService.member).subscribe(member => {

      if (member) {
        const historyItem: IMemberHistory = {
            id: member?.id,
            tenantId: member?.tenantName,
            base64: member?.base64,
            firstName: member?.firstName,
            lastName: member?.lastName,
            url: window.location.origin,
            date: new Date()
        };
        this.setHistory(historyItem);
      }
    });
  }

  private toSorted(items: IMemberHistory[]): IMemberHistory[] {
    return [...items].sort((a, b) => new Date(b.date).getTime() - new Date(a.date).getTime());
  }

  @DataAction()
  setHistory(@Payload('history') newHistory: IMemberHistory) {

      this.ctx.setState(produce(this.ctx.getState(), (draft: IMemberHistoryModel) => {

        // Ensure all members have a date property (this can go waay if you are sure all members will have a date)
        for (const member of draft.loadedMembers) {
            if (!member.hasOwnProperty('date') || member.date === undefined || member.date === null) {
                member.date = new Date();
            }
        }

        // Check if the new history item already exists
        const existingIndex = draft.loadedMembers.findIndex(m =>
            m.id === newHistory.id && m.tenantId === newHistory.tenantId && m.base64 === newHistory.base64
        );

        // If it exists, update the date; otherwise, add a new item
        if (existingIndex > -1) {
            draft.loadedMembers[existingIndex].date = new Date();
        } else {
          draft.loadedMembers.push({ ...newHistory, date: new Date() });
        }

        // Sort by date descending and keep only the latest 25 items
        draft.loadedMembers = this.toSorted(draft.loadedMembers).slice(0, 25);
        })
      );
  }

  public getHistory() {
    return this.snapshot.loadedMembers || [];
  }
}
